import { createApi } from '@reduxjs/toolkit/query/react';
import { SystemNotification } from '@scaleup/models';

import { baseQuery } from './baseQuery';
import { TagTypes } from './tagTypes';

export const notificationApi = createApi({
  reducerPath: 'notificationApi',
  tagTypes: [TagTypes.notification],
  baseQuery: baseQuery,
  endpoints: (builder) => ({
    getNotifications: builder.query<SystemNotification[], void>({
      query: () => 'notification',
      providesTags: [TagTypes.notification],
    }),
    markAsAcknowledged: builder.mutation<void, string>({
      query: (id) => ({
        url: `notification/${id}`,
        method: 'PUT',
        body: { markAsAcknowledged: true },
      }),
      invalidatesTags: [TagTypes.notification],
    }),
    markasViewed: builder.mutation<void, string>({
      query: (id) => ({
        url: `notification/${id}`,
        method: 'PUT',
        body: { markAsViewed: true },
      }),
      invalidatesTags: [TagTypes.notification],
    }),
  }),
});

export const {
  useGetNotificationsQuery,
  useMarkAsAcknowledgedMutation,
  useMarkasViewedMutation,
} = notificationApi;
